// extracted by mini-css-extract-plugin
module.exports = {"OrderFooter":"OrderCreatePage_OrderFooter__3kTYC","ButtonRow":"OrderCreatePage_ButtonRow__R3uLF","Modal":"OrderCreatePage_Modal__3f8yp"};